import React from 'react';
import { Button, Tooltip } from '@material-ui/core';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { updateAsset } from '../../redux/actions/manageAssetActions';
import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
	archived: {
		color: 'red',
		fontWeight: 'bold',
	},
}));

function AssetArchiveBtn({ asset }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const onButtonArchiveClick = () => {
		asset.archived = true;
		dispatch(updateAsset(asset));
	};
	const onButtonEnableClick = () => {
		asset.archived = false;
		dispatch(updateAsset(asset));
	};
	return (
		<div>
			{asset.archived ? (
				<Tooltip title="Archived assets are hidden from search" arrow={true} placement="top">
					<Button
						startIcon={<UnarchiveIcon />}
						className={classes.archived}
						size="large"
						onClick={onButtonEnableClick}
						data-cy="unarchive-asset"
					>
						Asset Archived
					</Button>
				</Tooltip>
			) : (
				<Button
					startIcon={<ArchiveOutlinedIcon />}
					color="primary"
					size="large"
					onClick={onButtonArchiveClick}
					data-cy="archive-asset"
				>
					Archive Asset
				</Button>
			)}
		</div>
	);
}

export default AssetArchiveBtn;
